import { datesToISO } from "@";
import type { SearchValues } from "../types";

export const searchValuesPayload = (
  page: number,
  perSize: number | null,
  search: Partial<SearchValues> = {},
) => ({
  page,
  pageSize: perSize,
  customerName: search?.customerName,
  toDate: datesToISO(search?.toDate),
  customerPhone: search?.customerPhone,
  fromDate: datesToISO(search?.fromDate),
  giftSenderName: search?.giftSenderName,
  giftProjectName: search?.giftProjectName,
  giftReceiverName: search?.giftReceiverName,
  giftReceiverPhone: search?.giftReceiverPhone,
  giftProjectOrderItemDesignStatus: search?.giftProjectOrderItemDesignStatus
    ? parseInt(search.giftProjectOrderItemDesignStatus)
    : null,
});
